export var ImageOtherEnum;
(function (ImageOtherEnum) {
    ImageOtherEnum["car"] = "car";
    ImageOtherEnum["moto"] = "moto";
    ImageOtherEnum["vehicleParts"] = "vehicleParts";
    ImageOtherEnum["presence"] = "presence";
})(ImageOtherEnum || (ImageOtherEnum = {}));
